import styled, { css } from 'styled-components';
import type { Badge } from '../../../../types';
import { IconsItem } from './IconsItem';

export function Icons({ icons }: { icons: Badge[] }) {
  return (
    <IconsComponent>
      {icons &&
        icons.map((data, id) => <StyledIconsItem data={data} key={id} />)}
    </IconsComponent>
  );
}

export const IconsComponent = styled.div`
  display: flex;
  flex-direction: row;
  margin: 12px -10px -12px;
  overflow: hidden;
  flex-wrap: wrap;
`;

const StyledIconsItem = styled(IconsItem)`
  min-width: 96px;
  margin: 0 10px 12px;
  ${({ theme: { windowWidth } }) =>
    windowWidth > 608 &&
    css`
      width: calc(25% - 20px);
    `};

  ${({ theme: { windowWidth } }) =>
    windowWidth <= 608 &&
    css`
      width: calc(50% - 20px);
    `};
`;
